export default {"src":"/uk/_next/static/media/hybrid-app-intro-screen-two.1367a9bb.svg","height":148,"width":300,"blurWidth":0,"blurHeight":0};